import { P } from '../theme/tokens';

export const LISTING_STATUS = {
  leased: { label: 'Occupied', color: P.success },
  turn: { label: 'Being prepared', color: P.warning },
  coming_soon: { label: 'Coming soon', color: P.warning },
  available: { label: 'Available now', color: P.info },
  pending: { label: 'Application pending', color: P.info },
  off_market: { label: 'Off-market', color: P.subtle }
};
